import Business from './Business.page';

export default Business;
